import React, { useEffect } from 'react';
import HomeSlider from '../Componte/HomeCompontes/HomeSlider';
import Category from '../Componte/HomeCompontes/Category';
import FeaturedHospitalSection from '../Componte/HomeCompontes/FeaturedHospitalSection';
import DirectorySection from '../Componte/HomeCompontes/DirectorySection';
import AboutUsSection from '../Componte/HomeCompontes/AboutUsSection';
import LocationSection from '../Componte/HomeCompontes/LocationSection';
import WhyChooseUsSection from '../Componte/HomeCompontes/WhyChooseUsSection';
import TopDoctorsSections from '../Componte/HomeCompontes/TopDoctorsSections';
import WorkProcessSection from '../Componte/HomeCompontes/WorkProcessSection';
import BlogSection from '../Componte/HomeCompontes/BlogSection';
import BrandSection from '../Componte/HomeCompontes/BrandSection';
// NOTE: All class attributes changed to className;
//       Comments changed from <!-- ... --> to {/* ... */}
//       Self-closing img tags, attributes formatted for JSX.

const HomeScreen = () => {

    return (
        <>
        <div className="bg-ash">
            {/* Hero Section Start */}
            <HomeSlider />
            {/* Hero Section End */}
            <Category />
            {/* Category Section End */}
        </div>
        <FeaturedHospitalSection />
        {/* Featured Hospital Section End */}
        <DirectorySection />
        {/* Directory Section End */}
        <AboutUsSection />
        {/* About Us Section End */}
        <LocationSection />
        {/* Location Section End */}
        <WhyChooseUsSection />
        {/* Why Choose Us Section End */}
        <TopDoctorsSections />
        {/* Top Doctors Sections End */}
        <WorkProcessSection />
        {/* Work Process Section End */}
        <BlogSection />
        {/* Blog Section End */}
        <BrandSection />
        {/* Brand Section End */}
        </>
    );
};

export default HomeScreen;
